/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmMemoryStoresListEntries } from "../../funcs/llmMemoryStoresListEntries.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListMemoryEntriesRequest$inboundSchema,
};

export const tool$llmMemoryStoresListEntries: ToolDefinition<typeof args> = {
  name: "llm-memory-stores-list-entries",
  description: `List memory entries`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmMemoryStoresListEntries(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
